export default "__VITE_ASSET__BtvlW91v__"